import { v4 as uuidv4 } from 'uuid';

const getUUID = (): string => uuidv4();

export default getUUID;
